'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var V1 = exports.V1 = 'V1';
var HIDE_WIDGET = exports.HIDE_WIDGET = 'HIDE_WIDGET';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/widget-data/constants/widgetDataTypes.js
// module id = 858
// module chunks = 2 3